import {Component, Inject, Input, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-control-calidad-contenido',
  templateUrl: './control-calidad-contenido.component.html',
  styleUrls: ['./control-calidad-contenido.component.scss']
})
export class ControlCalidadContenidoComponent implements OnInit {
    showSearch = true
    guardado = false
    @Input() GeneralSearchActive = false
    constructor(@Inject(DOCUMENT) private document: Document,) { }

  ngOnInit(): void {
      this.document.location.href.split('/').forEach(l => {
          if ( l === 'registro-guardado') {
              this.guardado = true
          }
      })
  }
  open() {}
    activar(l: string) {
        this.guardado = false

        if ( l === 'guardado') {
            this.guardado = true
        }
    }
}
